/** Sidebar sections and the one-line purpose of each screen. */
export const pages = {
  dashboard: {
    to: '/',
    title: 'Dashboard',
    description:
      'API status, real survivors and raid counts (test accounts left out), and the published content version.',
  },
  items: { to: '/content/items', title: 'Items' },
  lootTables: { to: '/content/loot-tables', title: 'Loot tables' },
  recipes: { to: '/content/recipes', title: 'Recipes' },
  baseModules: { to: '/content/modules', title: 'Base modules' },
  zombies: { to: '/content/zombies', title: 'Zombies' },
  categories: { to: '/content/categories', title: 'Categories' },
  roomTemplates: { to: '/content/rooms', title: 'Room templates' },
  raidRules: { to: '/content/raid-rules', title: 'Raid rules' },
  winds: { to: '/content/wind-tiers', title: 'Wind tiers' },
  survival: { to: '/content/survival', title: 'Survival rules' },
  bases: { to: '/content/bases', title: 'Bases and outposts' },
  noiseRadii: { to: '/content/noise', title: 'Noise radii' },
  survivorTraits: { to: '/content/traits', title: 'Survivor traits' },
  teamRules: { to: '/content/team-rules', title: 'Team rules' },
  discovery: { to: '/content/discovery', title: 'Discovery' },
  container: { to: '/content/container', title: 'Container' },
  convoy: { to: '/content/convoy', title: 'Convoy' },
  encounters: { to: '/content/encounters', title: 'Encounters' },
  worldEvents: { to: '/content/world-events', title: 'World events' },
  store: { to: '/content/store', title: 'Store' },
  characters: { to: '/content/characters', title: 'Characters' },
  resurrection: { to: '/content/resurrection', title: 'Resurrection' },
  squadRules: { to: '/content/squad-rules', title: 'Squad rules' },
  conditions: { to: '/content/conditions', title: 'Conditions' },
  bosses: { to: '/content/bosses', title: 'Bosses' },
  triggers: { to: '/content/triggers', title: 'Triggers' },
  missions: { to: '/content/missions', title: 'Missions' },
  cosmetics: { to: '/content/cosmetics', title: 'Cosmetics' },
  beatChains: { to: '/content/beat-chains', title: 'Beat chains' },
  allies: { to: '/content/allies', title: 'Allies' },
  story: { to: '/content/story', title: 'Story rules' },
  scenarios: { to: '/content/scenarios', title: 'Scenarios' },
  setPieces: { to: '/content/set-pieces', title: 'Set pieces' },
  worldFlags: { to: '/content/world-flags', title: 'World flags' },
  npcs: { to: '/content/npcs', title: 'NPCs' },
  pronounSets: { to: '/content/pronouns', title: 'Pronoun sets' },
  panelRules: { to: '/content/panel-rules', title: 'Panel rules' },
  chanceEvents: { to: '/content/chance-events', title: 'Chance events' },
  occupied: { to: '/content/occupied', title: 'Occupied buildings' },
  crews: { to: '/content/crews', title: 'Crews' },
  humans: { to: '/content/humans', title: 'Humans' },
  tells: { to: '/content/tells', title: 'Tells' },
  rescues: { to: '/content/rescues', title: 'Rescues' },
  holdouts: { to: '/content/holdouts', title: 'Holdouts' },
  holdoutRules: { to: '/content/holdout-rules', title: 'Holdout rules' },
  techTree: { to: '/content/tech-tree', title: 'Content tree' },
  techTiers: { to: '/content/tech-tiers', title: 'Tech tiers' },
  crafting: { to: '/content/crafting', title: 'Crafting' },
  fieldKit: { to: '/content/field-kit', title: 'Field kit' },
  siteKinds: { to: '/content/site-kinds', title: 'Site kinds' },
  keyParts: { to: '/content/key-parts', title: 'Key parts' },
  keyPartRules: { to: '/content/key-part-rules', title: 'Key-part rules' },
  whereSpawn: { to: '/content/where-would-it-spawn', title: 'Where would it spawn?' },
  vehicles: { to: '/content/vehicles', title: 'Vehicles' },
  arenaTemplates: { to: '/content/arena-templates', title: 'Arena templates' },
  arenaRules: { to: '/content/arena-rules', title: 'Arena rules' },
  lureSites: { to: '/content/lure-sites', title: 'Lure sites' },
  overwatch: { to: '/content/overwatch', title: 'Overwatch' },
  arcs: { to: '/content/arcs', title: 'Arcs' },
  storyRules: { to: '/content/story-issue-rules', title: 'Story issue rules' },
  tutorialRules: { to: '/content/tutorial-rules', title: 'Day Zero rules' },
  coreStats: { to: '/content/core-stats', title: 'Core stats' },
  skills: { to: '/content/skills', title: 'Skills' },
  perks: { to: '/content/skill-perks', title: 'Perks' },
  skillRules: { to: '/content/skill-rules', title: 'Skill rules' },
  names: { to: '/content/names', title: 'Names' },
  statusEffects: { to: '/content/effects', title: 'Effects' },
  effectRules: { to: '/content/effect-rules', title: 'Effect rules' },
  healthRules: { to: '/content/health-rules', title: 'Health rules' },
  zones: { to: '/content/zones', title: 'Zones' },
  backgrounds: { to: '/content/backgrounds', title: 'Backgrounds' },
  homeRules: { to: '/content/home-rules', title: 'Home rules' },
  storageGroups: { to: '/content/storage-groups', title: 'Storage groups' },
  buildCategories: { to: '/content/build-categories', title: 'Build categories' },
  inventoryRules: { to: '/content/inventory-rules', title: 'Inventory rules' },
  loadoutRules: { to: '/content/loadout-slots', title: 'Loadout slots' },
  overwatchAttempts: { to: '/overwatch-attempts', title: 'Overwatch attempts' },
  publish: { to: '/publish', title: 'Publish' },
  players: { to: '/players', title: 'Players' },
  purchases: { to: '/purchases', title: 'Purchases' },
  healthSources: { to: '/health/sources', title: 'Health sources' },
  playtestMetrics: { to: '/playtest', title: 'Playtest metrics' },
  saves: { to: '/saves', title: 'Save points' },
  triggerCodes: { to: '/trigger-codes', title: 'Trigger codes' },
  triggerRedemptions: { to: '/trigger-redemptions', title: 'Redemptions' },
  buildings: { to: '/buildings', title: 'Buildings' },
  audit: { to: '/audit', title: 'Audit log' },
} as const;

export type PageKey = keyof typeof pages;

export const navSections: { label: string | null; items: PageKey[] }[] = [
  { label: null, items: ['dashboard'] },
  // Live ops sits right under the Dashboard (admin tools, 2026-10-08): it's what support work opens most.
  {
    label: 'Live ops',
    items: [
      'players',
      'saves',
      'purchases',
      'healthSources',
      'playtestMetrics',
      'triggerCodes',
      'triggerRedemptions',
      'overwatchAttempts',
      'buildings',
      'audit',
    ],
  },
  {
    label: 'Content',
    items: [
      'items',
      'lootTables',
      'recipes',
      'baseModules',
      'zombies',
      'categories',
      'roomTemplates',
      'raidRules',
      'winds',
      'survival',
      'bases',
      'noiseRadii',
      'survivorTraits',
      'teamRules',
      'discovery',
      'container',
      'convoy',
      'encounters',
      'worldEvents',
      'store',
      'characters',
      'resurrection',
      'squadRules',
      'conditions',
      'bosses',
      'triggers',
      'missions',
      'cosmetics',
      'publish',
    ],
  },
  {
    // The homebase redesign and lite-RPG stats (card 17), and the Effects system (card 18).
    label: 'Homebase and stats',
    items: [
      'coreStats',
      'skills',
      'perks',
      'skillRules',
      'names',
      'statusEffects',
      'effectRules',
      'healthRules',
      'zones',
      'backgrounds',
      'homeRules',
      'storageGroups',
      'buildCategories',
      'inventoryRules',
      'loadoutRules',
    ],
  },
  {
    label: 'Stories',
    items: [
      'beatChains',
      'allies',
      'story',
      'scenarios',
      'setPieces',
      'worldFlags',
      'npcs',
      'pronounSets',
      'panelRules',
      'chanceEvents',
      'occupied',
      'crews',
      'humans',
      'tells',
      'rescues',
      'holdouts',
      'holdoutRules',
      'arcs',
      'storyRules',
      'tutorialRules',
    ],
  },
  {
    label: 'Workshop',
    items: [
      'techTree',
      'techTiers',
      'crafting',
      'fieldKit',
      'siteKinds',
      'keyParts',
      'keyPartRules',
      'whereSpawn',
    ],
  },
  {
    label: 'Scenes',
    items: ['vehicles', 'arenaTemplates', 'arenaRules', 'lureSites', 'overwatch'],
  },
];
